


























































































































































import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import TheLayoutBase from "@/layouts/TheLayoutBase.vue";
import { handleError } from "@/lib/utility/handleError";
import { SignDigitalSignatureRequestSignerViewModelGen } from "@/services/sign/v1/data-contracts";
import { ConfigModule } from "@/store/modules/config";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import DocumentDetailCardEditor from "../sign/DocumentDetailCardEditor.vue";
import DocumentDetailEditorMixin from "../sign/DocumentDetailEditorMixin.vue";
import DocumentTemplateDetailPageList from "../sign/DocumentTemplateDetailPageList.vue";
import SignFormEditorCanvas from "./SignFormEditorCanvas.vue";
import SignFormEditorControls from "./SignFormEditorControls.vue";
import SignFormEditorInputList from "./SignFormEditorInputList.vue";
import SignFormSignaturePageListSheet from "./SignFormSignaturePageListSheet.vue";
import { ISignDocument } from "@/models/sign-document.entity";

@Component({
  components: {
    TheLayoutBase,
    LayoutReport,
    Debug,
    DocumentDetailCardEditor,
    SignFormEditorCanvas,
    DocumentTemplateDetailPageList,
    SignFormEditorControls,
    SignFormEditorInputList,
    SignFormSignaturePageListSheet
  }
})
export default class SignFormEditor extends mixins(DocumentDetailEditorMixin) {
  @Ref("detailCardEditor")
  detailCardEditor!: DocumentDetailCardEditor;

  @Prop()
  document!: ISignDocument;

  @Prop()
  signRequest!: SignDigitalSignatureRequestSignerViewModelGen;

  readonly PAGE_LIST_ID = "pagelistsheet";

  isLoading = false;

  clientWidth = 0;
  clientHeight = 0;

  get isHeadless() {
    return ConfigModule.headless;
  }

  get isVerticalPageList() {
    return this.pages.length > 1 && !this.$vuetify.breakpoint.smAndDown;
  }

  get isHorizontalPageList() {
    return this.pages.length > 1 && this.$vuetify.breakpoint.smAndDown;
  }

  get highlightedToken() {
    const index = DocumentTemplateModule.highlightedToken;
    if (index === -1) {
      return undefined;
    }

    (this.$refs.textField as any)?.focus();

    return DocumentTemplateModule.documentTokens[this.currentPageNumber][index];
  }

  async mounted() {
    this.isLoading = true;
    DocumentTemplateModule.setHighlightedToken(-1);
    await this.initialize(this.document).catch(handleError);
    this.isLoading = false;
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
  }

  @Watch("currentPageNumber")
  onPageChange() {
    document.getElementById(`${this.PAGE_LIST_ID}${this.currentPageNumber}`)?.scrollIntoView({ behavior: "smooth" });
  }

  getSelector() {
    return this.detailCardEditor.selector;
  }

  resetHighlightedToken() {
    DocumentTemplateModule.setHighlightedToken(-1);
  }

  setCurrentPage(currentPageNumber: number) {
    this.currentPageNumber = currentPageNumber;
    DocumentTemplateModule.setCurrentPage(this.currentPageNumber);
  }

  onResize() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
  }

  previousPage() {
    if (this.currentPageNumber === 0) {
      this.currentPageNumber = this.pages.length - 1;
      DocumentTemplateModule.setCurrentPage(this.currentPageNumber);
      return;
    }
    this.currentPageNumber = this.currentPageNumber - 1;
    DocumentTemplateModule.setCurrentPage(this.currentPageNumber);
  }

  nextPage() {
    if (this.currentPageNumber === this.pages.length - 1) {
      this.currentPageNumber = 0;
      DocumentTemplateModule.setCurrentPage(this.currentPageNumber);

      return;
    }
    this.currentPageNumber = this.currentPageNumber + 1;
    DocumentTemplateModule.setCurrentPage(this.currentPageNumber);
  }
}
